import { AddPhotoAction } from './addPhoto.enum';
import { AddPhotoActions, AddPhotoState } from './addPhoto.types';

export const addPhotoReducer: (
  state: AddPhotoState, action: AddPhotoActions
) => AddPhotoState = (
  state: AddPhotoState, action: AddPhotoActions
): AddPhotoState  => {
  switch (action.type) {
    case AddPhotoAction.SetFileProgressValues:
      return {
        ...state,
        fileProgressValues: {
          ...state.fileProgressValues,
          [action.payload.fileName]: action.payload.percentLoaded
        },
      };
  }
};
